import type { CSSProperties } from 'react';

// Local copy of MUI's `visuallyHidden`. MUI only ships it from `@mui/utils`, which is
// documented as internal and isn't a declared dependency here.
export const visuallyHidden: CSSProperties = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
};
